import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hideListDialog } from '../../store/slice/dialogSlice'
import ArticleIcon from '@mui/icons-material/Article'
import { updateRFQMainIdSlice } from '../../store/slice/bidsSlice'
import { DataGrid } from '@mui/x-data-grid'
import { GridToolbar } from '../GridToolbar/GridToolbar'
import CloseIcon from '@mui/icons-material/Close'
import { head } from 'lodash'
import { useGetBIDsRFQListQuery } from '../../store/api/bidsApi'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../pages/Procurement/BIDs/constants'
import { rfqListColumns } from '../../pages/Procurement/BIDs/columns'
import Table from '../../helpers/table'
import { useGetCurrentUserInfoQuery } from '../../store/api/userApi'

const RFQListDialog = ({ formIsDisabled }) => {
  const dispatch = useDispatch()
  const open = useSelector((state) => state.dialogSlice.listDialog)
  const bidsMainFilterSlice = useSelector((state) => state.bidsSlice.bidsMainFilterSlice)
  const { data: currentUserDate } = useGetCurrentUserInfoQuery()

  const [rfqMainId, setRfqMainId] = useState(0)
  const dynamicKey = 'rfqMainId'
  const {
    data: rfqData,
    isLoading,
    refetch,
  } = useGetBIDsRFQListQuery(bidsMainFilterSlice?.businessUnitId || currentUserDate?.data?.defaultBusinessUnitId)
  const gridSizeDialog = useSelector((state) => state.dataGridSlice.size)

  const handleClose = () => {
    dispatch(hideListDialog())
  }

  const rows =
    rfqData?.data?.map((item) => {
      return { ...item, id: item.rfqMainId, rfqDeadline: dayjs(item.rfqDeadline).format(DATE_FORMAT) }
    }) || []

  const [visibleColumns, setVisibleColumns] = useState(
    Table.generateVisibleFields(rfqListColumns(), 'BIDsRFQList', { id: false })
  )

  useEffect(() => {
    localStorage.setItem('BIDsRFQList', JSON.stringify(visibleColumns))
  }, [visibleColumns])

  useEffect(() => {
    if (open) {
      refetch()
    }
  }, [open])

  return (
    <div>
      <Dialog
        fullWidth={!formIsDisabled}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100% !important',
              maxWidth: `${formIsDisabled ? '500' : '1000'}px !important`,
            },
          },
        }}
      >
        <>
          <DialogTitle>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div
                style={{
                  marginRight: 20,
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ fontWeight: 'bold', marginRight: 5 }} variant="h4" component="span">
                  {'RFQs List'}
                </Typography>
              </div>

              <IconButton
                className="test-icon-button"
                sx={{
                  '& svg': {
                    width: '25px !important',
                    height: '25px !important',
                  },
                }}
                size="large"
                aria-label="start"
                color="primary"
                onClick={() => {
                  handleClose()
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <Divider />

          <DialogContent>
            {!formIsDisabled && (
              <Box sx={{ height: 500, width: '100%' }}>
                <DataGrid
                  rows={rows || []}
                  columns={rfqListColumns()}
                  onRowDoubleClick={(params) => {
                    dispatch(updateRFQMainIdSlice(params.id))
                    handleClose()
                  }}
                  onSelectionModelChange={(newSelection) => setRfqMainId(head(newSelection))}
                  components={{
                    Toolbar: () => <GridToolbar hiddenSize={true} hiddenSearch={false} />,
                  }}
                  density={gridSizeDialog}
                  loading={isLoading}
                  columnVisibilityModel={visibleColumns}
                  onColumnVisibilityModelChange={(newModel) => setVisibleColumns(newModel)}
                  getRowId={(row) => row[dynamicKey]}
                  checkboxSelection={false}
                  pageSize={25}
                  pagination
                  showCellRightBorder
                />
              </Box>
            )}
          </DialogContent>
        </>
        <DialogActions style={{ marginRight: 20 }}>
          {!formIsDisabled && (
            <Button
              disabled={!rfqMainId}
              onClick={() => {
                dispatch(updateRFQMainIdSlice(rfqMainId))
                handleClose()
              }}
              variant="contained"
              startIcon={<ArticleIcon />}
            >
              {'Add RFQ'}
            </Button>
          )}

          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            {'Cancel'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default RFQListDialog
